const {debounce} = require('./Debounce');

class AutoScrollSectionNavigation {
    constructor(sectionNavigation) {
        this.currentActiveLink = null;
        this.navigationContainer = sectionNavigation;
        this.animationFrameId = null;
        window.addEventListener(
            'scroll',
            debounce(() => this.centerActiveLink(), 500)
        );
        this.navigationContainer?.addEventListener('click', event => this.handleClick(event));
    }

    getOffsetTop(element) {
        let offsetTop = 0;
        while (element && element !== this.navigationContainer) {
            if (element.offsetParent !== null) {
                offsetTop += element.offsetTop;
            }
            element = element.offsetParent;
        }
        return offsetTop;
    }

    centerActiveLink() {
        const activeLink = this.navigationContainer?.querySelector('[aria-current="true"]');
        if (activeLink && activeLink !== this.currentActiveLink) {
            // to stop auto scrolling when the user using the menu or on a section without any title
            this.currentActiveLink = activeLink;
            const containerHeight = this.navigationContainer.offsetHeight;
            const elementOffsetTop = this.getOffsetTop(activeLink);
            const elementHeight = activeLink.offsetHeight;
            const targetScrollTop = elementOffsetTop - containerHeight / 2 + elementHeight / 2;
            this.smoothScrollTo(this.navigationContainer, targetScrollTop, 1000);
        }
    }

    smoothScrollTo(element, target, duration) {
        const start = element.scrollTop;
        const change = target - start;
        const startTime = performance.now();

        const animateScroll = currentTime => {
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            // To ease in, for y < 0.5 : y = 2 * x * x
            // To ease out, for y >= 0.5 : y = − 1 + ( 4 − 2 * x )x
            const easeInOutQuad = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
            element.scrollTop = start + change * easeInOutQuad;

            if (timeElapsed < duration) {
                this.animationFrameId = requestAnimationFrame(animateScroll);
            } else {
                this.animationFrameId = null;
            }
        };

        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }

        this.animationFrameId = requestAnimationFrame(animateScroll);
    }

    handleClick(event) {
        if (event.target.tagName === 'A' && event.target.getAttribute('href')) {
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
                this.animationFrameId = null;
            }
        }
    }
}

module.exports = AutoScrollSectionNavigation;
